/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("userContributionDetailsRouter", ["userContributionDetailsModule"]).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("usercontributiondetails", {
        url: "/usercontributiondetails?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@usercontributiondetails": {
                templateUrl: 'header/backstageHeader_tpl.html',
                controller: 'backstageHeaderCtrl'
            },
            "main@usercontributiondetails": {
                templateUrl: "./main/backstage/ugcManage/userContribution/userContributionDetails/userContributionDetails_tpl.html",
                controller: "userContributionDetailsCtrl"
            }
        }
    });
}]);